<template>
    <div class="modal fade" id="startConversationNewSeller" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content" v-if="writingMessageBool">
                <div class="modal-header justify-content-center mb-5">
                    <h1 class="modal-title mt-0 heading-large">
                        <span>Open new account request to {{account.name}} </span>
                    </h1>
                    <button type="button" class="modal-close" @click="closeModal()" aria-label="Close">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <label> Message: </label>
                    <textarea class="w-100" rows="10" v-model="message" />
                </div>
                <div class="modal-footer justify-content-center ">
                    <button class="btn btn-neutral" @click="closeModal()">Cancel</button>
                    <button class="btn btn-confirm" @click="sendMessageToAccount()">Send Message</button>
                </div>
            </div>
            <!-- Confirmation screen after sending request -->
            <div v-else class="modal-content confirmation">
                <div class="modal-header pt-5 justify-content-center mb-5">
                    <h1 class="modal-title mt-0 heading-xlarge"> 
                        <i class="far fa-check-circle text-t_green mr-2 fa-lg"></i>
                        <span> Request Sent </span>
                    </h1>
                    <button type="button" class="modal-close" aria-label="Close" @click="closeModal()" >
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex flex-column align-items-center mb-4">
                        <span> Thank you for your request! </span>
                        <span> The Supplier will respond to you soon. </span>
                    </div>
                    <div>
                        <address class="d-flex justify-content-center mb-5"> 
                            <span> Chat now with {{account.name}} on </span>
                            <button type="button" class="btn btn-link pl-1" @click="goToOlfChatCloseModal(counterpartUserId)"> OLF Chat </button>
                            <i class="fas fa-comments text-t_blue"></i>
                        </address>
                    </div>
                </div>
                <div class="modal-footer mb-4 justify-content-center">
                    <button class="btn btn-neutral w-25" @click="closeModal()"> Close </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ConversationStarterMixin from './../mixins/ConversationStarterMixin'

export default {
    data(){
        return {
            message: "Hi, I'd like to open an account. Please can you advise on the next steps. Thank you very much.",
            writingMessageBool: true,
            serverResponse: '',
            counterpartUserId : ''
        }
    },
    props:['account'],
    mounted() {
        $('#startConversationNewSeller').modal('show');
    },
    mixins:[ConversationStarterMixin],
    methods: {
        sendMessageToAccount: async function(){
            const accountUserid = await this.getUserToStartChat(this.account);
            this.counterpartUserId = accountUserid;
            this.startConversation(accountUserid).then(response =>{
                if (response.data.success){
                    const payload = {
                        conversationId: response.data.createdConversationId,
                        message: this.message
                    }
                    const message = this.sendMessage(payload);
                }
                this.writingMessageBool = false;
                if(!this.account.enabled)
                    this.$emit('toggleValue',this.account);
            }).catch(err =>{
                if(!this.account.enabled)
                    this.$emit('toggleValue',this.account);
                this.goToOlfChat(this.counterpartUserId);
                this.closeModal()
            });
        },
        goToOlfChatCloseModal(counterpartUserId){
            this.closeModal();
            this.goToOlfChat(counterpartUserId);
        },
        closeModal(){
            $('#startConversationNewSeller').modal('hide')
            this.$emit('hideStartConversation')
            this.writingMessageBool = true
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>
